var map = {
	"./alert-solid.svg": 56376,
	"./alert.svg": 57830,
	"./approve-submission.svg": 44236,
	"./approved.svg": 59298,
	"./audience-match.svg": 55185,
	"./camera.svg": 92572,
	"./carousel.svg": 93711,
	"./chevron-down.svg": 85342,
	"./chevron-left.svg": 97533,
	"./chevron-right.svg": 40435,
	"./chevron-up.svg": 86136,
	"./circle-minus-solid.svg": 29355,
	"./circle-minus.svg": 58076,
	"./circle-plus-heavy.svg": 67535,
	"./circle-plus-solid.svg": 67508,
	"./circle-plus.svg": 38109,
	"./circle.svg": 85983,
	"./close-x.svg": 47062,
	"./comments.svg": 75200,
	"./compare-submission.svg": 22188,
	"./content-campaign.svg": 4705,
	"./content.svg": 22029,
	"./cross-heavy.svg": 41232,
	"./cross.svg": 26877,
	"./data.svg": 24714,
	"./decline-submission.svg": 27823,
	"./declined.svg": 45290,
	"./document-csv.svg": 28893,
	"./document-doc.svg": 86488,
	"./document-pdf.svg": 90014,
	"./edit.svg": 93289,
	"./external-link.svg": 34328,
	"./feedback.svg": 65117,
	"./filter.svg": 53083,
	"./full-screen-heavy.svg": 93502,
	"./gift.svg": 46392,
	"./heart-solid.svg": 79764,
	"./heart.svg": 46771,
	"./idea-pin.svg": 39986,
	"./images-solid.svg": 15548,
	"./inbox.svg": 30396,
	"./information-heavy.svg": 29156,
	"./information.svg": 69481,
	"./insights.svg": 59063,
	"./license-content-2.svg": 88033,
	"./license-content.svg": 16289,
	"./location-pin.svg": 65158,
	"./locked.svg": 34101,
	"./menu.svg": 78948,
	"./minus.svg": 67169,
	"./more-vertical.svg": 32244,
	"./more.svg": 13909,
	"./nav-back-default.svg": 16420,
	"./nav-back-short.svg": 80653,
	"./nav-fwd-short.svg": 16778,
	"./notes-creators.svg": 1109,
	"./notes.svg": 15182,
	"./notification-dot.svg": 32094,
	"./notifications.svg": 54865,
	"./picture-heavy.svg": 91257,
	"./picture.svg": 35286,
	"./pin-solid.svg": 43021,
	"./pin.svg": 82523,
	"./play.svg": 69413,
	"./plus-heavy.svg": 38078,
	"./plus.svg": 7164,
	"./preview.svg": 98610,
	"./profile.svg": 22345,
	"./rate-card-aud.svg": 19457,
	"./rate-card-gbp.svg": 69758,
	"./rate-card-usd.svg": 50977,
	"./reels.svg": 20226,
	"./schedule.svg": 30139,
	"./search.svg": 99413,
	"./select.svg": 21467,
	"./send.svg": 9155,
	"./share-android.svg": 77531,
	"./share-ios.svg": 78670,
	"./share-universal.svg": 69108,
	"./shorts.svg": 78009,
	"./snap.svg": 68969,
	"./social-facebook-colour.svg": 49469,
	"./social-facebook-f.svg": 16166,
	"./social-facebook.svg": 6498,
	"./social-instagram-colour.svg": 29763,
	"./social-instagram.svg": 60674,
	"./social-pinterest-colour.svg": 94285,
	"./social-pinterest.svg": 28311,
	"./social-snapchat-colour.svg": 37946,
	"./social-snapchat.svg": 22509,
	"./social-tiktok-colour.svg": 36497,
	"./social-tiktok.svg": 4959,
	"./social-x-colour.svg": 13011,
	"./social-x.svg": 87020,
	"./social-youtube-colour.svg": 23558,
	"./sort.svg": 41406,
	"./spinner.svg": 69979,
	"./star-rating-outline.svg": 46475,
	"./star-rating.svg": 90303,
	"./story.svg": 1985,
	"./text-post.svg": 40037,
	"./tick-heavy.svg": 36985,
	"./tick-solid.svg": 85640,
	"./tick.svg": 42626,
	"./tiktok.svg": 57920,
	"./tip.svg": 997,
	"./trash.svg": 89213,
	"./video.svg": 89950,
	"./view-by-creator.svg": 45107,
	"./view-by-list.svg": 69154,
	"./view-by-tile.svg": 93833,
	"./warning-heavy.svg": 68738,
	"./warning-solid.svg": 56401,
	"./warning.svg": 51825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70511;